/* eslint-disable no-unused-vars */
import { ProFormaModelIds } from 'constants/proForma';

export enum ColumnKeys {
    NAME = 'name',
    PERCENT_OF_INCOME = 'percentOfIncome',
    PRICE_PER_SF = 'pricePerSf',
    PRICE_PER_UNIT = 'pricePerUnit',
    AMOUNT_PER_YEAR = 'amountPerYear',
}

export const COLUMN_KEYS_BY_MODEL_ID: Record<string, ColumnKeys[]> = {
    [ProFormaModelIds.APARTMENT]: [
        ColumnKeys.NAME,
        ColumnKeys.PERCENT_OF_INCOME,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_UNIT,
        ColumnKeys.AMOUNT_PER_YEAR,
    ],
    // additional mappings here for other models
};
